import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const fetcher = (url, params) => api.get(url, { params }).then((r) => r.data);

export const useFormationList = (params) =>
  useQuery({ queryKey: ["formations", params], queryFn: () => fetcher("/formations", params) });

export const useFormationCategories = () =>
  useQuery({ queryKey: ["formation-categories"], queryFn: () => fetcher("/formation-categories"), staleTime: 300_000,
    select: (d) => (Array.isArray(d) ? d : (d?.categories || [])) });

export const useFormation = (slug) =>
  useQuery({ queryKey: ["formation", slug], queryFn: () => fetcher(`/formations/${slug}`), enabled: !!slug });

export const useMyFormations = (enabled = true) =>
  useQuery({ queryKey: ["my-formations"], queryFn: () => fetcher("/my/formations"), enabled });

export const useMyCertificates = (enabled = true) =>
  useQuery({ queryKey: ["my-certificates"], queryFn: () => fetcher("/my/certificates"), enabled });

export function useBuyFormation() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return async (formation) => {
    if (!user) {
      toast.message("Connectez-vous pour acheter cette formation");
      navigate("/connexion", { state: { from: `/formations/${formation.slug}` } });
      return;
    }
    try {
      const { data } = await api.post(`/formations/${formation.id}/purchase`);
      if (data.free) {
        toast.success("Formation débloquée !");
        navigate(`/mes-formations/${data.formation_id}`);
      } else {
        navigate(`/paiement/${data.order_number}`);
      }
    } catch (e) {
      toast.error(apiError(e));
    }
  };
}
